import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { apiCache } from "../../data/services/api-cache"
import { ApplicationState } from "../types"

export const useIsSmrtlinkLite = () => {
    const [isServerSmrtLinkLite, setIsServerSmrtLinkLite] = useState<boolean>(false)

    // Dev/QA override from the /dev page, so Lite-only behavior can be exercised
    // against a non-Lite server.
    const isDevSmrtLinkLite = useSelector<ApplicationState, boolean>(
        state => state.dev.isSmrtLinkLiteEnabled)

    useEffect( () => {
        apiCache.getSlStatus().then ( slStatus => {
            const isLite = slStatus.apiFlags && slStatus.apiFlags.isSmrtLinkLite
            setIsServerSmrtLinkLite(isLite)
        })
    }, [])
    return isServerSmrtLinkLite || isDevSmrtLinkLite
}
